import { Div, type DivProps } from "@hopper-ui/components";
import type { PropsWithChildren } from "react";
import "./StaggeredAnimation.css";

export type StaggeredAnimationItemProps = PropsWithChildren<DivProps>;

export const StaggeredAnimationItem = ({ children, ...rest }: StaggeredAnimationItemProps) => {
    return (
        <Div
            className="wai-staggered-animation-item"
            {...rest}
        >
            {children}
        </Div>
    );
};
